<template>
  <section :data-theme="theme" v-intersection-observer="onIntersectionObserver">
    <div class="hero min-h-screen bg-base-100 p-4" >
      <!-- mt-12 md:mt-0 ??? -->
      <div class="hero-content flex-col lg:flex-row-reverse">
        <img :src="iconHome()" class="max-w-sm hidden md:block" />
        <div>
          <h3 class="text-5xl font-bold">Hola soy Rodrigo Fernández</h3>
          <h4 class="py-6 text-4xl">Desarrollador Front-end</h4>
          <div class="flex justify-center">
            <div class="p-2">
              <a
                href="/Cv-Fernandez-Rodrigo.pdf"
                download="Cv-Fernandez-Rodrigo.pdf"
                class="btn btn-primary drop-shadow-2xl text-black"
                >Descargar CV</a
              >
            </div>
            <div class="p-2">
              <a
                class="btn bg-[#0a66c2] btn-square"
                href="https://www.linkedin.com/in/rodrigo-fernandez-590878106/"
                target="_blank"
              >
                <LinkedInIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import LinkedInIcon from "@/assets/icons/linkedIn.vue";
import { useStore } from "vuex";
import { ref } from "vue";

import { vIntersectionObserver } from "@vueuse/components";

const isVisible = ref(false);

function onIntersectionObserver([{ isIntersecting }]) {
  if (isIntersecting) {
    store.dispatch("setTheme", theme.value);
  }
  isVisible.value = isIntersecting;
}

const theme = ref("night");
const store = useStore();

const iconHome = () => {
  return require(`@/assets/images/programming.svg`);
};

</script>
